<template>
  <b-container id="new-trainer">
    <h1 class="title">Add Trainer</h1>
    <div id="alerts">
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
      >You have successfully added a trainer!</b-alert>
      <b-alert
        :show="showError"
        dismissible
        variant="warning"
      >Something went Wrong. Please refresh and try again.</b-alert>
    </div>
    <b-row>
      <b-col>
        <h4>Register Trainer as User</h4>
        <b-modal id="user-failure-modal" title="REGISTRATION ERROR">
          <p class="error">
            Something went wrong! Please try again, or contact your site's
            administrator
          </p>
        </b-modal>
        <b-modal id="user-success-modal" title="Registered User Info">
          <p>
            Please write this information down in a safe space; you cannot
            change a user's password!
          </p>
          <p class="my-4">
            <span>Email:</span>
            <span class="bi">{{ email }}</span>
          </p>
          <p class="my-4">
            <span>Password:</span>
            <span class="bi">{{ password }}</span>
          </p>
        </b-modal>
        <b-form-group>
          <div id="username" class="mt-4">
            <label for="username">User's name:</label>
            <b-form-input v-model="user_name" type="text" name="username" />
          </div>
          <div id="email" class="mt-4">
            <label for="email">Email:</label>
            <b-form-input
              v-model="email"
              type="email"
              name="email"
              v-validate="'required|email'"
              :class="{ input: true, 'is-danger': errors.has('email') }"
            />
            <p v-if="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>
          </div>
          <div id="password" class="mt-4">
            <label for="password">Password:</label>
            <b-form-input
              type="password"
              v-model="password"
              name="password"
              placeholder="password"
            />
          </div>
          <p v-if="password.length < 6" class="error">Your password must be longer than 5 characters</p>
          <div id="confirm" class="mt-4">
            <label for="confirm">Confirm password:</label>
            <b-form-input
              type="password"
              v-model="confirm"
              name="confirm"
              placeholder="Confirm password"
            />
          </div>
          <p v-if="password !== confirm" class="error">Your passwords do not match</p>
          <p v-if="confirm.length < 6" class="error">Your password must be longer than 5 characters</p>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <basic-info singular="trainer" plural="trainers"></basic-info>
      </b-col>
      <b-col>
        <trainer-designation></trainer-designation>
      </b-col>
      <b-col>
        <contact-info singular="trainer" plural="trainers"></contact-info>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <active-input plural="trainers" singular="trainer"></active-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <geo-info plural="trainers" singular="trainer" :coords="false"></geo-info>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <trainer-education></trainer-education>
      </b-col>
    </b-row>
    <confirm-submit></confirm-submit>
    <b-button
      :size="'lg'"
      :variant="'primary'"
      class="app_trainer_btn mb-4"
      :disabled="isDisabled"
      @click.prevent="addTrainer"
    >Add Trainer</b-button>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import BasicInfo from "@/components/BasicInfo";
import TrainerDesignation from "@/components/TrainerDesignation";
import TrainerEducation from "@/components/TrainerEducation";
import ConfirmSubmit from "@/components/ConfirmSubmit";
import ContactInfo from "@/components/ContactInfo";
import GeoInfo from "@/components/GeoInfo";
import ActiveInput from "@/components/ActiveInput";
import { flash } from "../mixins/flashes";

export default {
  name: "NewTrainer",
  mixins: [flash],
  components: {
    BasicInfo,
    GeoInfo,
    TrainerDesignation,
    ConfirmSubmit,
    ActiveInput,
    TrainerEducation,
    ContactInfo
  },
  data() {
    return {
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      isDisabled: false
    };
  },
  methods: {
    ...mapActions({
      RESET_TRAINERS_STATE: "trainers/RESET_TRAINERS_STATE",
      CREATE_TRAINER: "trainers/CREATE_TRAINER"
    }),
    async addTrainer() {
      if (!this.$store.state.confirmed) {
        alert("Please confirm the information above is correct");
        return;
      }
      if (
        this.$store.state.trainers.user.password !==
          this.$store.state.trainers.user.confirm ||
        this.$store.state.trainers.user.email.length === 0 ||
        this.$store.state.trainers.trainer.first_name.length === 0 ||
        this.$store.state.trainers.trainer.last_name.length === 0 ||
        this.$store.state.trainers.trainer.sex.length === 0
      ) {
        window.scrollTo(0, 0);
        this.$bvModal.show("user-failure-modal");
        this.flashError();
      } else {
        this.isDisabled = true;
        await this.CREATE_TRAINER();
        window.scrollTo(0, 0);
        this.$bvModal.show("user-success-modal");
        await this.flashSuccess();
        await this.$store.commit("resetConfirmed");
        this.isDisabled = false;
        setTimeout(() => this.RESET_TRAINERS_STATE(), 20000);
      }
    }
  },
  computed: {
    email: {
      get() {
        return this.$store.state.trainers.user.email;
      },
      set(val) {
        this.$store.commit("trainers/userEmail", val);
      }
    },
    user_name: {
      get() {
        return this.$store.state.trainers.user.user_name;
      },
      set(val) {
        this.$store.commit("trainers/userName", val);
      }
    },
    password: {
      get() {
        return this.$store.state.trainers.user.password;
      },
      set(val) {
        this.$store.commit("trainers/password", val);
      }
    },
    confirm: {
      get() {
        return this.$store.state.trainers.user.confirm;
      },
      set(val) {
        this.$store.commit("trainers/confirm", val);
      }
    }
  },
  created() {
    this.RESET_TRAINERS_STATE();
  }
};
</script>

<style scoped>
.form div {
  margin: 20px;
}
.app_trainer_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}

div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
.bi {
  font-weight: bold;
  font-style: italic;
}
</style>
